<div class="wrapper">
  <div [ngClass]="(isToggle==true)?'sidebar-line _active':'sidebar-line'"></div>
  <section [ngClass]="(isToggle==true)?'hidden_section _active':'hidden_section'"></section>
  <section class="page_body _bank_reconciliation" [ngStyle]="{'width':isToggle?'85%':'98%'}">
    <a [ngClass]="(isToggle==true)? (deviceType==='Desktop') ? 'open_nav_link _active' : (deviceType==='Mobile') ?'open_nav_link _active mini' : 'open_nav_link _active tablet':'open_nav_link'" (click)="toggle()">
      @if (!isToggle) {
        <span class="__icon _close"><mat-icon class="mat-icon-center">menu</mat-icon></span>
      }
      @if (isToggle) {
        <span class="__icon _open"><mat-icon class="mat-icon-center">chevron_left</mat-icon></span>
      }
    </a>
    <cmp-bread-crumbs></cmp-bread-crumbs>
    <router-outlet></router-outlet>
  </section>
</div>